/**
 * Members' optional-processing choices (cookie / storage preferences).
 *
 * Midgard currently uses only necessary storage, so OPTIONAL_CATEGORIES is
 * empty and no consent banner is shown. Any future optional category (e.g.
 * analytics) must be added here, default to off, and only load its scripts
 * after hasConsent(category) is true.
 */
import versions from '../content/legalVersions.json';

const KEY = 'midgard_privacy_choices';

// { id, label, description } — none today.
export const OPTIONAL_CATEGORIES = [];

export function readChoices() {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || 'null');
    return raw && raw.policy === versions.documents.cookies.version ? raw : null;
  } catch {
    return null;
  }
}

export function saveChoices(granted) {
  const value = { policy: versions.documents.cookies.version, granted, saved_at: new Date().toISOString() };
  try { localStorage.setItem(KEY, JSON.stringify(value)); } catch { /* storage blocked */ }
  return value;
}

export const hasConsent = (category) => !!readChoices()?.granted?.[category];
export const needsConsentPrompt = () => OPTIONAL_CATEGORIES.length > 0 && !readChoices();
